import { Icons } from "assets";
import { routeConstant } from "shared/routes/routeConstant";

const sideBarConstants: SideBarItemsType[] = [
  {
    title: "Main",
    paths: [
      {
        path: routeConstant.dashboard.path,
        title: routeConstant.dashboard.title,
        Icon: Icons.DashboardHome,
      },
    ],
  },
  {
    title: "",
    paths: [
      {
        path: routeConstant.dashboardCustomers.path,
        title: routeConstant.dashboardCustomers.title,
        Icon: Icons.Customers,
      },
    ],
  },
  {
    title: "",
    paths: [
      {
        path: routeConstant.dashboardSuppliers.path,
        title: routeConstant.dashboardSuppliers.title,
        Icon: Icons.Suppliers,
      },
    ],
  },
  {
    title: "",
    paths: [
      {
        path: routeConstant.dashboardTransactions.path,
        title: routeConstant.dashboardTransactions.title,
        Icon: Icons.Transactions,
      },
    ],
  },
  {
    title: "",
    paths: [
      {
        path: routeConstant.dashboardBlogs.path,
        title: routeConstant.dashboardBlogs.title,
        Icon: Icons.Blogs,
      },
    ],
  },
  {
    title: "",
    paths: [
      {
        path: routeConstant.dashboardPolicies.path,
        title: routeConstant.dashboardPolicies.title,
        Icon: Icons.Policies,
      },
    ],
  },
  {
    title: "",
    paths: [
      {
        path: routeConstant.dashboardSupportMessages.path,
        title: routeConstant.dashboardSupportMessages.title,
        Icon: Icons.SupportMessages,
      },
    ],
  },
  {
    title: "",
    paths: [
      {
        path: routeConstant.dashboardNewsletterEmails.path,
        title: routeConstant.dashboardNewsletterEmails.title,
        Icon: Icons.NewsLetter,
      },
    ],
  },
  {
    title: "",
    paths: [
      {
        path: routeConstant.dashboardSettings.path,
        title: routeConstant.dashboardSettings.title,
        Icon: Icons.Settings,
      },
    ],
  },
];

export { sideBarConstants };
